import { GlobalAxios } from "../axios/axios-config";

const ACCESS_CONTROL_SECTOR_SEND_RESTART_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/AccessControlSectorSend/RestartAccessControlSectorSend";

export const restartAccessControlSectorSend = ({
  identifier,
}: {
  identifier: number;
}) => {
  return GlobalAxios.put(ACCESS_CONTROL_SECTOR_SEND_RESTART_ROUTE, {
    identifier,
  });
};
